import { Couriers } from "../../components/Couriers/Couriers";

export const CouriersPage = () => {
    return(
        <div className="container__pages">
            <h2>Lista de Couriers</h2>
            <div className="container_form">
                <Couriers/>
            </div>
        </div>
    );
}